"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const SurveyErrorPage_1 = __importDefault(require("../pages/SurveyErrorPage"));
const react_redux_1 = require("react-redux");
const errorHandling_1 = require("../../services/errorManagement/errorHandling");
/**
 * Error boundary component to catch exceptions in react components and display
 * a fallback UI.
 */
class ErrorBoundary extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.resetErrorBoundary = () => {
            this.setState({ hasError: false });
        };
        this.state = { hasError: false };
    }
    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({ hasError: true });
        console.log('An exception occurred in a react component', error, info);
        (0, errorHandling_1.logClientSideMessage)(error, { interviewId: this.props.interviewId });
    }
    render() {
        if (this.state.hasError) {
            // Go to error page as fallback UI
            return react_1.default.createElement(SurveyErrorPage_1.default, { onRedirect: this.resetErrorBoundary });
        }
        return this.props.children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
const BoundaryWithoutId = (props) => {
    const interviewId = (0, react_redux_1.useSelector)((state) => { var _a; return (_a = state.survey.interview) === null || _a === void 0 ? void 0 : _a.id; });
    return react_1.default.createElement(ErrorBoundary, { interviewId: interviewId }, props.children);
};
exports.default = BoundaryWithoutId;
//# sourceMappingURL=ErrorBoundary.js.map